import { ErrorCode } from '@api';
import { FALLBACK_ERROR_MESSAGE_KEY } from '@api/errors/constants/global-error-message-keys.constant';

export const AUTH_ERROR_MESSAGE_KEYS_BY_ERROR_CODE = {
  AUTH_PROCONNECT_CANCELLED: 'errors.authProconnectCancelled',
  AUTH_PROCONNECT_FAILED: 'errors.authProconnectFailed',
  AUTH_PROCONNECT_IDENTITY_INCOMPLETE: 'errors.authProconnectIdentityIncomplete',
  AUTH_PROCONNECT_SIREN_UNKNOWN: 'errors.authProconnectSirenUnknown',
  EXT_PROCONNECT_UNAVAILABLE: 'errors.extProconnectUnavailable',
  ACCOUNT_PENDING: 'errors.accountPending',
  ACCOUNT_REJECTED: 'errors.accountRejected',
  ACCOUNT_SUSPENDED: 'errors.accountSuspended',
  INVALID_CREDENTIALS: 'errors.invalidCredentials',
  AUTH_LOCAL_LOGIN_REPLACED_BY_PROCONNECT: 'errors.authPasswordLoginReplacedByProconnect',
  INVALID_ACCESS_TOKEN: 'errors.sessionExpired',
  SESSION_EXPIRED: 'errors.sessionExpired',
  ADMISSION_REFUSED: 'errors.admissionRefused',
  EMAIL_NOT_VERIFIED: 'errors.emailNotVerified',
  ACCOUNT_DELETED: 'errors.accountDeleted',
  EMAIL_ALREADY_REGISTERED: 'errors.emailAlreadyRegistered',
  EMAIL_VERIFICATION_TOKEN_INVALID: 'errors.tokenInvalid',
  EMAIL_VERIFICATION_TOKEN_EXPIRED: 'errors.tokenExpired',
  PASSWORD_RESET_TOKEN_INVALID: 'errors.tokenInvalid',
  PASSWORD_RESET_TOKEN_EXPIRED: 'errors.tokenExpired',
  PASSWORD_RESET_SAME_AS_CURRENT: 'errors.passwordResetSameAsCurrent',
  PASSWORD_RESET_UNSUPPORTED_FOR_PROCONNECT: 'errors.passwordResetUnsupportedForProconnect',
  PASSWORD_RESET_COOLDOWN_ACTIVE: 'errors.tooManyRequests',
  RATE_LIMITED: 'errors.tooManyRequests',
  VALIDATION_ERROR: 'errors.validationError',
} as const satisfies Partial<Record<ErrorCode, string>>;

export function getAuthErrorMessageKey(code: ErrorCode | undefined): string {
  return (
    (code && (AUTH_ERROR_MESSAGE_KEYS_BY_ERROR_CODE as Partial<Record<ErrorCode, string>>)[code]) ||
    FALLBACK_ERROR_MESSAGE_KEY
  );
}
